import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FloatingInteraction, FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';
import InfoIcon from 'ui-library/icons/InfoIcon';

export default function StartingTablesInfo(): JSX.Element {
  return (
    <span className={css(tablesInfoStyles.icon)}>
      <Popover
        interaction={FloatingInteraction.HOVER}
        renderContent={() => (
          <>
            <p>
              <strong>Variable:</strong> Upon template execution, users will be prompted to substitute this
              table with another.
            </p>
            <p>
              <strong>Static:</strong> Upon template execution, a copy of this table will be incorporated into
              the new analysis.
            </p>
          </>
        )}
        placement={FloatingPlacement.RIGHT}
      >
        <InfoIcon />
      </Popover>
    </span>
  );
}

const tablesInfoStyles = StyleSheet.create({
  icon: {
    marginLeft: 2,
  },
});
